export const paths = {
  APPLICATION_PATH: "/",
  HOME_PATH: "/home",
  ADMINISTRATION: "/administration",
  KNOWLEDGE_MANAGMENT: "/knowledgeManagement",
  KNOWLEDGE_ITEM: "/knowledgeItem",
  KNOWLEDGE: "/knowledge",
  MESSAGE_LOG_TYPE: "/messageLogType",
  CLASS_DEFINITION: "/classDefinition",
  ROLES: "/roleTypes",
  LIFE_CYCLE: "/lifeCycle",
  EXTENSION: "/extension",
  INDIVIDUALS: "/individuals",
  PARTYROLES: "/partyRoles",
  ADVANCED_SEARCH: "/advancedSearch",
  CLASSIFICATIONS: "/classification",
  DETAIL: "/detail",
  INVOLVEMENTROLETYPES: "/involvementRoleTypes",
  INVOLVEMENTROLETYPE: "/involvementRoleType",
  OPERATIONS: "/operations",
  INVOLVEMENTROLES: "/involvementRoles",
  SYSTEM: "/system",
  SUBSCRIPTIONS: "/subscriptions",
  PARTY_MESSAGES: "/notifications",
  ENTITY_RELATIONSHIP_TYPES: "/entityRelationshipTypes",
  README_PATH: "/readme",
  ORGANISATIONS: "/organisations"
};
